import { Directive, EventEmitter, HostListener, Input, OnDestroy, Output } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { FileDownloadService } from 'src/app/service/file-download.service';

export interface DownloadFileProgress {
  loadedBytes: number;
  totalBytes?: number;
}

export interface DownloadFileComplete {
  fileName: string;
  sizeBytes: number;
}

@Directive({
  selector: '[downloadFile]'
})
export class DownloadFileDirective implements OnDestroy {
  constructor(private readonly fileDownloadService: FileDownloadService) {}

  private downloadUrl: string;
  private fileNameSuggested: string = "file";
  private activeDownload: Subscription | null = null;

  @Input('downloadFile')
  public set url(url: string) {
    this.downloadUrl = url;
  };

  @Input('fileName')
  public set fileName(filename: string) {
    this.fileNameSuggested = filename;
  };

  @Output() downloadProgress = new EventEmitter<DownloadFileProgress>();
  @Output() downloadComplete = new EventEmitter<DownloadFileComplete>();
  @Output() downloadError = new EventEmitter<HttpErrorResponse>();

  @HostListener('click')
  public onClick(): void {
    if (this.activeDownload) {
      return;
    }
    this.activeDownload = this.fileDownloadService.download(this.downloadUrl, this.fileNameSuggested).subscribe({
      next: (event) => {
        if (event.kind === 'progress') {
          this.downloadProgress.emit({ loadedBytes: event.loadedBytes, totalBytes: event.totalBytes });
        } else {
          this.downloadComplete.emit({ fileName: event.fileName, sizeBytes: event.sizeBytes });
        }
      },
      error: (error: HttpErrorResponse) => {
        this.activeDownload = null;
        this.downloadError.emit(error);
      },
      complete: () => {
        this.activeDownload = null;
      },
    });
  }

  ngOnDestroy(): void {
    if (this.activeDownload) {
      this.activeDownload.unsubscribe();
      this.activeDownload = null;
    }
  }
}
